import React from 'react';

import PropTypes from 'prop-types';
import cn from 'classnames';
import { Icon } from '@picsio/ui';
import { TriangleArrowDown } from '@picsio/icons';

import localization from '../../../../../shared/strings';
import MediaThumbnailGrid from '../MediaThumbnailGrid';
import styles from '../../styles.module.scss';

function VariantMediaSection({
  variantLabel,
  poolAssets,
  selectedAssetIds,
  isExpanded,
  onToggleExpand,
  onSelectAsset,
  showValidationStatus,
  requirePublishReady,
}) {
  const strings = localization.DIALOGS.PRODUCT_DIALOGS.CONNECT_CHANNEL.VARIANT_MEDIA;
  const showGrid = isExpanded;
  const assignedCount = selectedAssetIds.length;
  const statusLabel = assignedCount
    ? strings.ASSETS_ASSIGNED(assignedCount)
    : strings.NOT_ASSIGNED;

  return (
    <div className={styles.connectChannelSectionVariantSection}>
      <div
        role="button"
        tabIndex={0}
        className={styles.connectChannelSectionVariantSectionHeader}
        onClick={onToggleExpand}
        onKeyDown={onToggleExpand}
      >
        <Icon
          size="lg"
          className={cn(styles.connectChannelSectionVariantSectionChevron, {
            [styles.connectChannelSectionVariantSectionChevronExpanded]: isExpanded,
          })}
        >
          <TriangleArrowDown />
        </Icon>
        <span className={styles.connectChannelSectionVariantSectionTitle}>{variantLabel}</span>
        <span
          className={cn(styles.connectChannelSectionVariantSectionStatus, {
            [styles.connectChannelSectionVariantSectionStatusAssigned]: assignedCount > 0,
          })}
        >
          {statusLabel}
        </span>
      </div>

      <If condition={showGrid}>
        <div className={styles.connectChannelSectionVariantSectionGrid}>
          <MediaThumbnailGrid
            assets={poolAssets}
            selectedAssetIds={selectedAssetIds}
            onAssetClick={onSelectAsset}
            tileSize="large"
            gridClassName={styles.connectChannelSectionVariantMediaGrid}
            tileClassName={styles.connectChannelSectionVariantMediaTile}
            showCheckbox
            showValidationStatus={showValidationStatus}
            requirePublishReady={requirePublishReady}
          />
        </div>
      </If>

      <div className={styles.connectChannelSectionVariantSectionDivider} />
    </div>
  );
}

VariantMediaSection.propTypes = {
  variantLabel: PropTypes.string.isRequired,
  poolAssets: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
  })).isRequired,
  selectedAssetIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggleExpand: PropTypes.func.isRequired,
  onSelectAsset: PropTypes.func.isRequired,
  showValidationStatus: PropTypes.bool,
  requirePublishReady: PropTypes.bool,
};

VariantMediaSection.defaultProps = {
  showValidationStatus: true,
  requirePublishReady: false,
};

export default VariantMediaSection;
